import {Component, HostListener, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";

@Component({
  selector: 'app-aarni-school-of-agriculture',
  templateUrl: './aarni-school-of-agriculture.component.html',
  styleUrls: ['./aarni-school-of-agriculture.component.scss']
})
export class AarniSchoolOfAgricultureComponent implements OnInit {
    testimonialSlideIndex: number = 0;
    testimonialSlidesCount: number = 3;
    groupedTestimonials: any[][] = [];
    testimonials = [
        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            designation: 'Hitech Engineering Industry, Malot',
            image: 'assets/img/home-page-testimonials/geetika-katoch.webp',
            feedback: `  The professors at ARNI are not just teachers; they are mentors who guide you at
                                    every step. Their real-world experience and industry insights make learning so much
                                    more engaging. Thanks to their career counseling, I was able to choose the right
                                    specialization for my MBA!`,
        },
        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            designation: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },
    ];
    /*testimonials = [
        {
            name: 'Ravi Mehta',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
            feedback: `Learning through ARNI was an outstanding experience for me. Apart from college lectures, we were allowed to spend time in the fields, nurseries, and greenhouse that helped to practice what we learned in the classroom. The hands-on experience helped me to understand modern farming and its challenges.`,
        },
        {
            name: 'Sanjay Yadav',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/44.jpg',
            feedback: `I had low confidence on me when I joined this course, but the way our mentors simplified the complex topics, I never felt lost in my classroom. The updated and well-structured course curriculum was enough for me to have growth in my career and learning opportunities.`,
        },
        {
            name: 'Amit Chauhan',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/43.jpg',
            feedback: `The campus of ARNI University is perfectly aligned with our learnings of agriculture. The lush green fields and beautiful surroundings not only provide easy access to practical learning but are peaceful, too, to motivate students. It is an ideal place to grow personally and professionally.`,
        },
        {
            name: 'Deepak Saini',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/45.jpg',
            feedback: `I always wanted to explore research in agriculture, and ARNI gave me that chance. I got to work on small research projects related to soil testing and organic farming. These experiences gave me confidence and helped me plan for higher studies.`,
        },
        {
            name: 'Pooja Sharma',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/43.jpg',
            feedback: `With the help of placement services at ARNI, I got a chance to work with a reputed agritech company right after my degree. The training sessions, career counseling, and soft skill workshops made me ready for the professional world.`,
        },
        {
            name: 'Anil Rawat',
            course: 'Bachelor of Science in Agriculture',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/46.jpg',
            feedback: `I enjoyed every moment of my journey at ARNI—from the classroom lectures to the agri-fairs, guest sessions, and friendly interactions with classmates. I’ve not only grown academically but also developed strong communication and leadership skills.`,
        }
    ];*/
    events = [
        {
            date: '23 Dec 2023',
            title: 'National Farmers Day',
            description: 'ARNI University celebrated National Farmers Day to honor the invaluable contributions of farmers through talks, exhibitions, and student-led activities.',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/events/event-image-agriculture2.webp'
        },
        {
            date: '23 Dec 2023',
            title: 'Honoring Farmers on Farmers Day',
            description: 'ARNI University proudly honored Farmers\' Day with gratitude-filled tributes, awareness sessions, and student participation, celebrating the backbone of our nation.',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/events/event-for-school-of-agriculture1.webp'
        },
        {
            date: '04 Nov 2023',
            title: 'Ek Ped Maa Ke Naam - Campaign 2024',
            description: 'ARNI University launched “Ek Ped Maa Ke Naam” Campaign 2024, promoting environmental awareness and honoring motherhood through meaningful tree plantations.',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/events/ek-ped-maa-k-naam-agriculture-event2.webp'
        },
        {
            date: '04 Nov 2023',
            title: 'Ek Ped Maa Ke Naam - Campaign 2024',
            description: 'The objective of the event was to encourage students and staff to plant trees in their mother’s name, fostering emotional bonding and environmental responsibility.',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/events/event-agriculture-ek-ped-maa-k-naam.webp'
        },
    ];
    departments = [
        { name: 'Agriculture', icon: 'fa-seedling',
            branch: 'Bsc. Agriculture' },
    ];
    faculties = [
        {
            name: 'Dr. Jai Prakash',
            designation: 'Dean, Arni School of Agriculture/Life Sciences',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/dr-jay-prakash-dean.webp',
        },
        {
            name: 'Dr. Sharad Kumar Tripathi',
            designation: 'Hod, Arni School of Life Sciences/Agriculture',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/dr-sharad-kumar-tripathi-hod.webp',
        },
        {
            name: 'Dr. Harish Kumar',
            designation: 'Assistant Professor, Arni School of Agriculture',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/dr-harish-kumar-assistant-professor-agriculture.webp',
        },
        {
            name: 'Dr. Nikhil',
            designation: 'Assistant Professor, Arni School of Agriculture',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/dr-nikhil-assistant-professor-agriculture.webp',
        },
        {
            name: 'Ms. Astha',
            designation: 'Assistant Professor, Arni School of Agriculture',
            image: 'assets/img/school-wise-faculties/arni-school-of-agriculture/ms-astha-assistant-professor-agriculture.webp',
        },
    ];
    index = 0;
    recruiters = [
        { name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png" },
        { name: "Amar Ujala", logo: "assets/img/companies/amarujala.png" },
        { name: "Amazon", logo: "assets/img/companies/Amazon.png" },
        { name: "CMC", logo: "assets/img/companies/cmc-logo_0.png" },
        { name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png" },
        { name: "Future Group", logo: "assets/img/companies/FutureGroup.png" },
        { name: "HCL", logo: "assets/img/companies/hcl.png" },
        { name: "ICICI", logo: "assets/img/companies/icici_securities.png" },
        { name: "Sleepwell", logo: "assets/img/companies/sleepwell.png" },
        { name: "SYNTEL", logo: "assets/img/companies/syntel2.png" },
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        { name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png" },
        { name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png" },
        { name: "Genpact", logo: "assets/img/companies/zenpact.png" },
        { name: "Reliance", logo: "assets/img/companies/amarujala.png" },
    ];

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }

    currentIndex = 0;
    translateX = 0;

    constructor(
        private meta: Meta,
        private titles: Title,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
        this.scrollToContent();
        this.groupTestimonials();
    }

    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;
        if (screenWidth >= 1024) {
            perSlide = 3;
        } else if (screenWidth >= 768) {
            perSlide = 2;
        } else {
            perSlide = 1;
        }
        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }
        this.groupedTestimonials = grouped;
        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        const tabContainer = document.querySelector('.tab-buttons'); // tab buttons wrapper
        const header = document.querySelector('header'); // your fixed header element, if any

        const tabHeight = tabContainer?.getBoundingClientRect().height || 0;
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const totalOffset = tabHeight + headerHeight + 15; // add extra padding to show section clearly

        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();

                tabs.forEach(t => t.classList.remove('active-tab'));
                (event.target as HTMLElement).classList.add('active-tab');

                const targetId = (event.target as HTMLElement).getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }
            });
        });
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.translateX = -this.currentIndex * 25;
        }
    }

    next() {
        if (this.currentIndex < this.faculties.length - 1) {
            this.currentIndex++;
            this.translateX = -this.currentIndex * 25;
        }
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at ARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at ARNI School of Technology. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }
}
